import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
  DataGridSemHeader,
} from '../../../components/index';
import {
  trataMensagensErro,
  trataMensagemSucesso,
  doPut,
  doPost,
  validateObject,
  requestValoresMediosBeneficios,
} from '../../../utils/requests';

class ModalValorMedioBeneficio extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    valorMedioBeneficio: {
      dataCompetencia: this.props.valorMedioBeneficioAlteracao.dataCompetencia,
      valorMedioBeneficio: this.props.valorMedioBeneficioAlteracao.valorMedioBeneficio,
    },
    valorAlteracao: this.props.valorMedioBeneficioAlteracao.valorMedioBeneficio,
    touched: false,
    validadeCampos: {
      dataCompetencia: true,
      valorMedioBeneficio: false,
    },
    acao: 'alterar',
    estadoFormulario: 'alteracao',
    noContentPrimaryMessage: 'Valor não encontrado para a competência informada.',
    noContentSecondaryMessage: 'Informe outra competência.',
  });

  componentDidMount() {
    this.montaFormulario();
  }

  componentWillUnmount() {
    if (this.state.valorAlteracao !== this.state.valorMedioBeneficio.valorMedioBeneficio) {
      this.buscarValoresMediosBeneficios('');
    }
  }

  buscarValoresMediosBeneficios = () => {
    requestValoresMediosBeneficios(this.handleErrorBusca, '');
  }

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível consultar o valor Médio do Beneficio.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  montaFormulario = () => {
    this.setState({
      validadeCampos: {
        ...this.state.validadeCampos,
        dataCompetencia: true,
        valorMedioBeneficio: false,
      },
    });
  }

  formularioProntoParaEnvio = () => {
    const { estadoFormulario } = { ...this.state };
    if (estadoFormulario === 'alteracao') {
      return validateObject(this.state.validadeCampos);
    }
    return false;
  }

  handleSaveButton = () => {
    this.confirmSendData();
  }

  handleChange = (changeObj, name, callback = null) => {
    const { valorMedioBeneficio } = { ...this.state };
    this.setState({
      valorMedioBeneficio: {
        ...valorMedioBeneficio,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    }, callback);
  }

  /**
   * Trata envio dos dados
   */
  confirmSendData = () => {
    let url = 'valores-medios-beneficios';
    const touched = true;
    const competenciaComBarra = this.state.valorMedioBeneficio.dataCompetencia;
    const competenciaPrimaParte = competenciaComBarra.substring(0, competenciaComBarra.indexOf('/'));
    const competenciaSeguParte = competenciaComBarra.substring(competenciaComBarra.indexOf('/') + 1, competenciaComBarra.toString().length);
    const compFinal = competenciaPrimaParte + competenciaSeguParte;
    if (this.props.acao !== 'novo') {
      // url = `requerimentos-compensacao-aposentadoria/${this.state.requerimento.protocolo}`;
      url = `valores-medios-beneficios/${compFinal}`;
    }
    // Alteração para transformar o valor do campo valorMedioBeneficio
    // para numero antes de persistir na tabela.
    if (typeof (this.state.valorMedioBeneficio.valorMedioBeneficio) !== 'number') {
      let valor = this.state.valorMedioBeneficio.valorMedioBeneficio;
      valor = valor.replace(/\./g, '').replace(/,/g, '.');
      this.state.valorMedioBeneficio.valorMedioBeneficio = Number(valor);
    }
    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
      requestPesquisa: null,
    }, () => this.handleSave(url));
  }

  /**
   * Trata as acoes dos botao Salvar "Criar Valor medio Beneficio"
   */
  handleSave = (url) => {
    if (this.formularioProntoParaEnvio()) {
      let options;
      if (this.state.chaveConfirmacao) {
        options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      }
      const { valorMedioBeneficio } = { ...this.state };
      if (this.props.acao === 'novo') {
        doPost(
          url,
          valorMedioBeneficio,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
          options,
        );
      } else {
        doPut(
          url,
          valorMedioBeneficio,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
        );
      }
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = () => {
    if (this.state.chaveConfirmacao) {
      this.setState({
        chaveConfirmacao: null,
        alertas: [],
        showModal: !this.state.showModal,
      }, this.trataSucesso);
    } else {
      this.trataSucesso();
    }
  }

  trataSucesso = () => {
    let mensagemSucesso = '';
    if (this.props.acao === 'novo') {
      mensagemSucesso = 'O valor da média foi criado.';
    } else {
      mensagemSucesso = 'O valor da média foi atualizado.';
    }

    this.setState({
      showAlteracaoValorMedioBeneficioModal: !this.state.showAlteracaoValorMedioBeneficioModal,
      valorMedioBeneficio: {
        dataCompetencia: null,
        valorMedioBeneficio: null,
      },
    }, this.handleClose);
    this.setState(this.buscarValoresMediosBeneficios(''));
    trataMensagemSucesso([mensagemSucesso]);
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  // Escolhe o titulo do modal baseado na acao
   determinaTitulo = () => {
     let titulo;
     if (this.props.acaoModal === 'criar') {
       titulo = 'Incluir valor da média';
     } else {
       titulo = 'Alterar valor da média';
     }
     return titulo;
   }

  modalValorMediaContent = () => (
    <React.Fragment>
      <DataGridSemHeader title="" icon="ico-money" >
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled="true"
              label="Competência"
              value={this.state.valorMedioBeneficio.dataCompetencia}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled={(!this.props.auth.checkPermission(['analisar-negocio-sprev']))}
              currency
              showMask={false}
              label="Valor da Média"
              error={!this.state.valorMedioBeneficio.valorMedioBeneficio}
              touched={this.state.touched}
              maxLength="16"
              value={this.state.valorMedioBeneficio.valorMedioBeneficio}
              required={(this.props.auth.checkPermission(['analisar-negocio-sprev']))}
              onChange={e => this.handleChange(e, 'valorMedioBeneficio')}
              onKeyUp={e => this.props.handleKeyUp(e, 'valorMedioBeneficio')}
            />
          </Grid>
        </div>
      </DataGridSemHeader>
    </React.Fragment>
  )

  modalValorMediaFooter = () => (
    <React.Fragment>
      <div className="right">
        {(this.props.auth.checkPermission(['gerenciar-negocio-dcomp', 'analisar-negocio-sprev'])) ?
          <Button
            className="dtp-primary"
            disabled={!this.formularioProntoParaEnvio()}
            hint="Salvar"
            onClick={this.handleSaveButton}
            title="Salvar"
          />
        : ''}
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.setState(this.props.handleModal('showAlteracaoValorMedioBeneficioModal'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalValorMediaFooter()}
        conteudomodal={this.modalValorMediaContent()}
        onHide={this.handleClose}
        size="lg"
        showModal={this.props.showModal}
        title={this.determinaTitulo()}
      />
    );
  }
}

ModalValorMedioBeneficio.propTypes = {
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  valorMedioBeneficioAlteracao: PropTypes.objectOf(PropTypes.object).isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default ModalValorMedioBeneficio;



// WEBPACK FOOTER //
// ./src/pages/cadastros/ValoresMediosBeneficios/ModalValorMedioBeneficio.jsx